import { NATIVE_HOST_INLINE_CHECK } from "@/platform/bridge/native-host-inline"
import { isAppBridgeAvailable } from "@/platform/bridge/use-native-bridge"

const BARE_TOP_ATTRIBUTE = "data-bare-top"

const PHONE_QUERY = "(max-width: 47.99rem)"

export const scrollPastTopBar = () => {
  if (window.location.hash || isAppBridgeAvailable() || !window.matchMedia(PHONE_QUERY).matches) return
  const bar = document.querySelector(`[${BARE_TOP_ATTRIBUTE}]`)
  if (!bar) return
  const bottom = Math.round(bar.getBoundingClientRect().bottom + window.scrollY)
  if (bottom > 0 && window.scrollY < bottom) window.scrollTo(0, bottom)
}

export const scrollPastTopBarScript = `(function(){
if(location.hash||${NATIVE_HOST_INLINE_CHECK}||!window.matchMedia('${PHONE_QUERY}').matches)return;
var bar=document.querySelector('[${BARE_TOP_ATTRIBUTE}]');
if(!bar)return;
var bottom=Math.round(bar.getBoundingClientRect().bottom+window.scrollY);
if(bottom>0&&window.scrollY<bottom)window.scrollTo(0,bottom);
})()`
